(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/services/deposit-service.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/services/deposit-service.js');

'use strict';

const jupiter = svs.core.jupiter;
const logger = svs.accountservicesReact.deposit.logger;

const getCurrentStatus = async () => {
  try {
    const _await$jupiter$callAs = await jupiter.callAsync({
        method: 'GET',
        path: '/player/3/info?include=currentStatus'
      }),
      response = _await$jupiter$callAs.response;
    return response ? response : {
      currentStatus: []
    };
  } catch (err) {
    logger.warn('Error fetching player info for checking currentStatus for DEPOSITS_SUSPENDED', err);
    return {
      currentStatus: []
    };
  }
};

const getSuspensions = async () => {
  try {
    const _await$jupiter$callAs2 = await jupiter.callAsync({
        method: 'GET',
        path: '/player/1/suspensions'
      }),
      response = _await$jupiter$callAs2.response;
    return response ? response : {
      suspensions: []
    };
  } catch (err) {
    logger.warn('Error fetching player suspensions', err);
    return {
      suspensions: []
    };
  }
};

const getNetLossRestrictions = async () => {
  try {
    const _await$jupiter$callAs3 = await jupiter.callAsync({
        method: 'GET',
        path: '/gcs/1/activenetlossrestriction'
      }),
      response = _await$jupiter$callAs3.response;
    return response ? response : null;
  } catch (err) {
    logger.warn('Error getting net loss restrictions', err);
    return null;
  }
};

const getDepositRestrictions = async () => {
  try {
    const _await$jupiter$callAs4 = await jupiter.callAsync({
        method: 'GET',
        path: '/gcs/1/depositdialog'
      }),
      response = _await$jupiter$callAs4.response;
    return response ? response : null;
  } catch (err) {
    logger.warn('Error getting depositdialog for deposit restrictions', err);
    return null;
  }
};

const getDayTimeLimit = async () => {
  try {
    const _await$jupiter$callAs5 = await jupiter.callAsync({
        method: 'GET',
        path: "/player/2/daytimelimit"
      }),
      response = _await$jupiter$callAs5.response;
    return response ? response : null;
  } catch (err) {
    logger.warn('Error getting players day time limit', err);
    return null;
  }
};

const putDepositAmount = async depositAmount => {
  try {
    const _await$svs$core$jupit = await svs.core.jupiter.callAsync({
        method: 'PUT',
        path: '/gcs/1/remainingdeposits',
        data: {
          remainingDeposits: depositAmount
        }
      }),
      response = _await$svs$core$jupit.response;
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error setting remainingdeposits', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error
    };
  } catch (err) {
    logger.warn('Error setting remainingdeposits', err);
    return {
      error: err
    };
  }
};
svs.accountservicesReact.deposit.services.depositService = {
  getSuspensions,
  getCurrentStatus,
  getNetLossRestrictions,
  getDepositRestrictions,
  getDayTimeLimit,
  putDepositAmount
};

 })(window);